import React, { useSelector } from "react";
import { fetchAllTimesheets } from "../../../../redux/timesheets/timesheetsActions";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    GridList,
    GridListTile,
    GridListTileBar,
    Typography,
} from "@material-ui/core";

import GetAppIcon from "@material-ui/icons/GetApp";
import { useStyles } from "../../adminStyles";
// const user = useSelector(state => state.users.all);
const AttachmentDialogue = props => {
    const {
        dialogTitleContainer,
        root,
        image,
        tileBar,
        downloadIcon,
        btn,
        dialogTitle,
    } = useStyles();

    const { attachmentOpen, handleAttachmentClose, userObj, rows } = props;
    const downloadURI = (uri, name) => {
        let a = document.createElement("a");
        a.href = uri;
        a.target = "_blank";
        a.setAttribute("download", name);
        a.click();
    };

    const renderAttachments = () => {
        return (
            userObj &&
            userObj.attachments &&
            userObj.attachments.map(att => {
                return (
                    <GridList cellHeight={250} spacing={5}>
                        <GridListTile key={""} cols={2} rows={1}>
                            <img
                                className={image}
                                alt="techmileage-logo"
                                src={`${att.attachmentUrl}`}
                            />
                            <GridListTileBar
                                className={tileBar}
                                title={`${att.fileName}`}
                                // subtitle={<span>{'Bob'}</span>}
                                actionIcon={
                                    <IconButton
                                        onClick={() => {
                                            downloadURI(
                                                att.attachmentUrl,
                                                att.fileName
                                            );
                                        }}
                                        aria-label={`info about ${"Download"}`}
                                        className={downloadIcon}
                                    >
                                        <GetAppIcon />
                                    </IconButton>
                                }
                            />
                        </GridListTile>
                    </GridList>
                );
            })
        );
    };

    return (
        <Dialog
            open={attachmentOpen}
            onClose={handleAttachmentClose}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle
                id="form-dialog-title"
                className={dialogTitleContainer}
            >
                <Typography variant="h5" className={dialogTitle}>
                    Attachments
                </Typography>
            </DialogTitle>
            <DialogContent>
                <div className={root}>
                    {
                        /* { rows && rows[0] && rows[0].attachments && rows[0].attachments.length && */
                        userObj &&
                            userObj.attachments &&
                            userObj.attachments.length &&
                            renderAttachments()
                    }
                </div>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button
                    onClick={handleAttachmentClose}
                    color="primary"
                    className={btn}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AttachmentDialogue;
